import { IsNumber, IsDefined } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { ContextService } from 'src/core/services/context.service';

export class PolicyDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.PolicyItem, Model.Bookings.Logic.ViewModels.PolicyItem, PolicyItem> {
	protected map(entity: Model.Bookings.Logic.ViewModels.PolicyItem): PolicyItem {
		return new PolicyItemModel(entity);
	}

	static make(ctx?: ContextService): PolicyDataService {
		return new PolicyDataService(ctx, ctx => ctx.Policies);
	}

	add(defaultLanguage: string): Promise<PolicyItem> {
		const entity = new Model.Bookings.Logic.ViewModels.PolicyItem();
		(entity as any).dynamicProperties = {
			displayName: {
				[defaultLanguage]: ''
			}
		};

		return this.create(() => entity);
	}
}

export class PolicyItemModel extends EntityModel<Model.Bookings.Logic.ViewModels.PolicyItem, PolicyItem> implements PolicyItem {
	@property<PolicyItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<PolicyItemModel>(o => o.entity.isActive, (o, value) => o.entity.isActive = value)
	public isActive: boolean;

	@property<PolicyItemModel>(o => o.entity.commission, (o, value) => o.entity.commission = value)
	@IsDefined({ message: 'Commission is required' })
	//@IsNumber( { message: 'commission must be a number' })
	public commission: number;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	public dynamicProperties: any;

	@property<PolicyItemModel>(o => o.entity.rules, (o, value) => o.entity.rules = value)
	public rules: PolicyRuleItem[];
}



// WEBPACK FOOTER //
// ./src/app/bookings/policies/form/policy-form.data.ts